module.exports = __webpack_public_path__ + "img/info_icon.fd51034e.svg";